import { useEffect } from 'react';
import { usePubSub } from '@/context/PubSubContext';

export function usePubSubEvent<T>(eventName: string, handler: (data: T) => void) {
  const { subscribe } = usePubSub();

  useEffect(() => {
    const unsubscribe = subscribe<T>(eventName, handler);
    return unsubscribe;
  }, [eventName, handler, subscribe]);
}
